import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import {FormBuilder,Validators,FormGroup, FormControl} from '@angular/forms';
import { Router} from '@angular/router';
// For social site login

import {HttpRequestService} from './../../_services/http-request.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import {CommonService} from './../../_services/common.service';
import Swal from 'sweetalert2'
import {NgbModal,NgbCalendar,NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { environment as env} from './../../../environments/environment';
@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  @ViewChild('userTypecontent', {static: false})userTypecontent: ElementRef;
  captchaConfig:any = {length:6, strokeColor:"#2F9688", font:{color:"#7278e5", size:"35px"}};

  public signUpForm: FormGroup;
  public educatorSignUpForm: FormGroup;
  public signupFormSubmitStatus: boolean = false;
  public educatorSignupFormSubmitStatus: boolean = false;
  public signupContent: any;
  public city_list:Array<any> = [];
  public captchaCode:any = null;
  //public maxDate: NgbDateStruct = this.calender.getToday();
  //public maxDate: NgbDateStruct = {year: 2007, month: 12, day: 31};
  public maxDate: NgbDateStruct;
  public minDate: NgbDateStruct;
  public choosedUserType:any=1;
  public userType='STUDENT';
  public settingsData:Array<any>=[];
  public currentlyWorkingStatus = 0;
  constructor(
    private formBilder: FormBuilder,
		private httpServices:HttpRequestService,
		public router: Router,
    private toastr: ToastrService,
    public translate: TranslateService,
    private cService: CommonService,
    private modalService: NgbModal,
    public calender: NgbCalendar,
  ) {
    this.cService.activelang.subscribe((lang) => {

      // this language will be used as a fallback when a translation isn't found in the current language
      translate.setDefaultLang(lang);

      // the lang to use, if the lang isn't available, it will use the current loader to get them
      translate.use(lang);
    });
  }

  ngOnInit() {
    const current = new Date();
    this.maxDate={
      year: current.getFullYear(),
      month: current.getMonth()+1,
      day: current.getDate()
    };
    this.minDate={
      year: current.getFullYear()-100,
      month: 1,
      day: 1
    };
    if(localStorage.getItem('_user')){
			this.router.navigate(['profile']);
    } else{
      this.getSettingData();
      this.signUpForm = this.formBilder.group({
        'user_type':['1'],
        'email':['',[Validators.required, Validators.email]],
        'confirm_email':['',[Validators.required, this.confirmEmailCheck.bind(this)]],
        'password':['', [Validators.required]],
        'first_name':['',[Validators.required]],
        'middle_name':[''],
        'last_name':['',[Validators.required]],
        'mobile_code':[null,[Validators.required]],
        // 'mobile_no':['',[Validators.required, Validators.pattern('(?=.*[0-9]).{10,}'), Validators.minLength(10),  Validators.maxLength(10)]],
        'mobile_no':['',[Validators.required, Validators.minLength(7),  Validators.maxLength(10)]],
        'dob':['',[Validators.required]],
        'birthday_display_status':[''],
        'country_id':[env.soudiCountryId,[Validators.required]],
        'city_id':['',[Validators.required]],
        'zip':['',[Validators.required]],
        'terms':['',[Validators.required]],
        'captcha':['',[Validators.required, this.checkCaptcha.bind(this)]],
        'lang':[localStorage.getItem('_lang')],
        'nationality':[null],
        'gender':[null,[Validators.required]],
        'guardian_mobile_code':[null],
        // 'guardian_mobile_no':['',[ Validators.pattern('(?=.*[0-9]).{10,}'), Validators.minLength(10),  Validators.maxLength(10)]],
        'guardian_mobile_no':['',[ Validators.minLength(7),  Validators.maxLength(10)]],
        'grade_level':[null],
        'school_name':[null]
      });
      this.educatorSignUpForm = this.formBilder.group({
        'user_type':['3'],
        'email':['',[Validators.required, Validators.email]],
        'confirm_email':['',[Validators.required, this.confirmEmailCheckEducator.bind(this)]],
        'password':['', [Validators.required]],
        'first_name':['',[Validators.required]],
        'middle_name':[''],
        'last_name':['',[Validators.required]],
        'mobile_code':['',[Validators.required]],
        //'mobile_no':['',[Validators.required, Validators.pattern('(?=.*[0-9]).{10,}'), Validators.minLength(10),  Validators.maxLength(10)]],
        'mobile_no':['',[Validators.required,  Validators.minLength(7),  Validators.maxLength(10)]],
        'dob':['',[Validators.required]],
        'birthday_display_status':[''],
        'country_id':[env.soudiCountryId,[Validators.required]],
        'city_id':['',[Validators.required]],
        'zip':['',[Validators.required]],
        'amount':[''],
        'currency':['SAR'],
        'customer_id':[],
        'card_type':['',[Validators.required]],
        'card_holder':['',[Validators.required,Validators.minLength(3),Validators.maxLength(255)]],
        'card_number':['',[Validators.required, Validators.minLength(16), Validators.maxLength(16)]],
        'card_expiryMonth':['',[Validators.required, Validators.minLength(2), Validators.maxLength(2)]],
        'card_expiryYear':['',[Validators.required, Validators.minLength(4), Validators.maxLength(4)]],
        'card_cvv':['',[Validators.required, Validators.minLength(3), Validators.maxLength(3)]],
        'save_card':[''],
        'terms':['',[Validators.required]],
        'captcha':['',[Validators.required, this.checkCaptcha.bind(this)]],
        'lang':[localStorage.getItem('_lang')],
        'nationality':[null],
        'currently_working_status':[null,[Validators.required]],
        'current_work_place':[null],
        'previous_work_place':[null],
        'work_status':[null],
        'gender':[null,[Validators.required]]
      });
      this.getSignUpContent();
      setTimeout(()=>{
        this.openUserTypeModal(this.userTypecontent);
      },20)
    }
    this.getCityFromCountry();
    this.getCityFromCountryEducator();
    
  }

  public getSettingData(){
    this.httpServices.setModule('action').post('site_settings',{}).subscribe((response:any) => {
        //console.log(response.data.settings,'fees');
      if (response.status == 'error') {
        this.toastr.error( response.data,'Error:');
      } else {
        //console.log(response.data.settings,"setting data");
        for(let i=0; i<response.data.settings.length; i++){
          let item = response.data.settings[i];
          // console.log(item);
          this.settingsData[item.param_name] = item.param_value;
        };
         console.log(this.settingsData['edcator_registration_fees'],"registration fees")
      }
    })
  }
  openUserTypeModal(content) {
    this.modalService.open(content, { size: 'xl', centered: true }).result.then((result) => {

    }, (reason) => {

    });
  }
  addUserType(type) {
    this.choosedUserType = type;
    if(this.choosedUserType==1){
      this.userType="STUDENT";
    } else if(this.choosedUserType == 2){
      this.userType = "PARENT";
    } else {
      this.userType = "EDUCATOR"
    }
    this.signUpForm.controls['user_type'].setValue(type);
    this.educatorSignUpForm.controls['user_type'].setValue(type);
    this.modalService.dismissAll();
  }
    /* Function Name : checkCaptcha
	* Author :
	* Created Date : 01-11-2019
	* Modified Date : *
	* Purpose : to validate captcha
	* PARAMS : control
	*/

  checkCaptcha(control: FormControl) {
    if (control.value) {
      const isValid = control.value === this.captchaCode;

      return isValid ? null : { 'invalid_captcha': true };
    }
  }
      /* Function Name : confirmEmailCheck
	* Author :
	* Created Date : 01-11-2019
	* Modified Date : *
	* Purpose : to validate confirmemail
	* PARAMS : control
	*/

  confirmEmailCheck(control: FormControl) {
    if (control.value) {
      const isValid = control.value === this.signUpForm.value.email;

      return isValid ? null : { 'email_mismatch': true };
    }
  }
  confirmEmailCheckEducator(control: FormControl){
    if (control.value) {
      const isValid = control.value === this.educatorSignUpForm.value.email;

      return isValid ? null : { 'email_mismatch': true };
    }
  }
  getSignUpContent(){
    const data = {
      lang:'EN'
    };
    this.httpServices.setModule('action').post('signup_content',data).subscribe((response) => {

      if (response.status=='success') {
          this.signupContent = response.data;
      }
      if (response.status=='error') {
        this.toastr.error( response.message,'Error');
      }
    }, (error) => {
      console.log(error);
    });
  }
  submitSignUpForm() {
    // console.log(this.signUpForm);
    this.signupFormSubmitStatus = true;
   
    if (this.signUpForm.valid) {
      this.httpServices.setModule('action').post('signup_action',this.signUpForm.value).subscribe((response) => {

        if (response.status=='success') {
          this.translate.get([
            'CONGRATULATION',
            'SIGNUP_SUCCESS_MSG'
          ]).subscribe((tData)=>{

            Swal.fire(tData['CONGRATULATION'], tData['SIGNUP_SUCCESS_MSG'], 'success')
            .then((result)=>{
              this.router.navigate(['']);
            })
          })
        }
        if (response.status=='error') {
          this.toastr.error( response.message,'Error:');
        }
      }, (error) => {
        console.log(error);
      });
    }
    // console.log(this.signUpForm.value);
  }

  getCityFromCountry() {
    let countryId = this.signUpForm.value.country_id;
    this.httpServices.setModule('action').post('city_by_country',{country_id:countryId,lang:localStorage.getItem('_lang')}).subscribe((response) => {

      if (response.status=='success') {
        this.city_list = response.data;
      }
      if (response.status=='error') {
        this.toastr.error( response.message,'Error:');
      }
    }, (error) => {
      console.log(error);
    });
  }

  getCityFromCountryEducator() {
    let countryId = this.educatorSignUpForm.value.country_id;
    this.httpServices.setModule('action').post('city_by_country',{country_id:countryId,lang:localStorage.getItem('_lang')}).subscribe((response) => {
      if (response.status=='success') {
        this.city_list = response.data;
      }
      if (response.status=='error') {
        this.toastr.error( response.message,'Error:');
      }
    }, (error) => {
      console.log(error);
    });
  }

  getcaptchaCode(code) {
    this.captchaCode = code;
  }

  // saveCard(e) {
  //   this.educatorSignUpForm.controls['save_card'].setValue(1);
  // }

  submitEducatorSignUpForm() {
 
    this.educatorSignupFormSubmitStatus = true;
   
    if (this.educatorSignUpForm.valid) {
      this.educatorSignUpForm.patchValue({ amount:this.settingsData['edcator_registration_fees']});
      this.httpServices.setModule('action').post('educator_signup_action',this.educatorSignUpForm.value).subscribe((response) => {
        if (response.status=='success') {
          this.translate.get([
            'CONGRATULATION',
            'SIGNUP_SUCCESS_MSG'
          ]).subscribe((tData)=>{

            Swal.fire(tData['CONGRATULATION'], tData['SIGNUP_SUCCESS_MSG'], 'success')
            .then((result)=>{
              this.router.navigate(['']);
            })
          })
        }
        if (response.status=='error') {
          this.toastr.error( response.message,'Error:');
        }
      }, (error) => {
        console.log(error);
      });
    }
 
  }

  currentlyWorking(event){
    if(event.target.value=="1"){
      this.currentlyWorkingStatus=1;
    } else{
      this.currentlyWorkingStatus=0;
    }
  }

}
